<header class="container-fluid">
  <a [routerLink]="['/datos-personales']" class="brand-link" aria-label="Banco Comafi">
    <img [src]="logoUrl" alt="Banco Comafi" class="brand-logo" />
  </a>
</header>
